import React, { useEffect } from "react";
import "../style/MarketPlace.css";
import FeaturedCollection from "../SubComponent/MarketPlace/FeaturedCollection";
import Landingpage from "../SubComponent/MarketPlace/Landingpage";
import Latest from "../SubComponent/MarketPlace/Latest";
import Popular from "../SubComponent/MarketPlace/Popular";
import Tabbing from "../SubComponent/MarketPlace/Tabbing";
import Topartist from "../SubComponent/MarketPlace/Topartist";
import Upcoming from "../SubComponent/MarketPlace/Upcoming";

function MarketPlace() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div className="container-fluid">
      <div className="mainContainer">
        <Landingpage />
        {/* <section>
          <div className="d-flex justify-content-between align-items-center pt100 pb-3">
            <div className="landingDesc">
              <h1>
              </h1>
              <h1>YOUR PLACE FOR</h1>
              <h1>
                <span>DIGITAL TATTOOS</span>
              </h1>
              <p className="pt-2">
              </p>
              <div className="d-flex gap-3 pt-3">
                <button className="explore text-uppercase"> Explore</button>
                <a className="Create" href="#">
                  Create
                </a>
              </div>
            </div>
            <div className="landingImage">
              <img src="image 7.png" alt="landingImage" />
            </div>
          </div>
        </section> */}
        <FeaturedCollection />
        <Tabbing />
        <Upcoming />
        <Topartist />
        <Popular />
        <Latest />
      </div>
    </div>
  );
}

export default MarketPlace;
